import { createUseStyles } from 'react-jss';
import { SpacingsValues } from '@picsart/cascade';

import { mediaQuery } from '../../../styles/helpers';
import { ITheme } from '../../../styles/theme';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      marginInline: 'auto',
      marginBottom: 40,
      maxWidth: 'min(100%, var(--max-width-02))',
      paddingInline: SpacingsValues.s24,

      [mediaQuery(breakpoints.tablet)]: {
        marginBottom: 0,
      },
    },

    mainImg: {
      display: 'block',
      marginInline: 'auto',
      marginBottom: SpacingsValues.s24,
      maxWidth: 648,

      [mediaQuery(breakpoints.mobile)]: {
        maxWidth: 'min(327px, 100%)',
      },
    },

    title: {
      color: 'var(--x-black-1)',
      marginBottom: SpacingsValues.s8,
      textAlign: 'center',

      [mediaQuery(breakpoints.tablet)]: {
        fontSize: 30,
        lineHeight: '36px',
      },
    },

    subtitle: {
      color: 'var(--x-black-1)',
      marginBottom: SpacingsValues.s24,
      textAlign: 'center',
    },

    upload: {
      borderRadius: 120,
      marginTop: SpacingsValues.s24,
      marginInline: 'auto',
      paddingBlock: SpacingsValues.s32,
      paddingInline: SpacingsValues.s24,
      textAlign: 'center',
      width: 'min(100%, 1100px)',

      [mediaQuery(breakpoints.tablet)]: {
        gap: 12,
        paddingBlock: SpacingsValues.s24,
      },
    },

    uploadTxt: {
      color: 'var(--x-text-color-4)',
    },

    demoImages: {
      marginInline: 'auto',
      marginBottom: SpacingsValues.s16,
      marginTop: SpacingsValues.s24,
    },
    demoImagesSubtitle: {
      color: 'var(--x-text-color-4)',
      marginBottom: SpacingsValues.s24,
      textAlign: 'center',
    },
    rating: {
      margin: 0,
      paddingBlock: 40,
    },
  }),
  {
    name: 'UploadSection',
  },
);

export default useStyles;
